import { AnnualRepeatRule } from '../../../lib/shared/calendar.types'

interface AnnualRecurrenceProps {
  rule: AnnualRepeatRule
  onChange: (rule: AnnualRepeatRule) => void
}

export function AnnualRecurrence({ rule, onChange }: AnnualRecurrenceProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Month
          </label>
          <select
            value={rule.month}
            onChange={(e) =>
              onChange({
                ...rule,
                month: parseInt(e.target.value),
              })
            }
            className="mt-1 block w-full rounded-md border border-grey-500 p-2 focus:border-blue-500 focus:ring-blue-500"
          >
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {new Date(2024, i, 1).toLocaleString('default', {
                  month: 'long',
                })}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Day of Month
          </label>
          <select
            value={rule.value}
            onChange={(e) =>
              onChange({
                ...rule,
                value: parseInt(e.target.value),
              })
            }
            className="mt-1 block w-full rounded-md border border-grey-500 p-2 focus:border-blue-500 focus:ring-blue-500"
          >
            {[...Array(31)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
          {rule.value >= 29 && rule.month === 2 && (
            <p className="mt-1 text-sm text-amber-600">
              For February, the event will occur on the last day (28th or 29th
              in leap years).
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
